module.exports = __webpack_public_path__ + "static/deregistration-241d49f65fd63a768970b0f946859b34.jpg";